/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  GamoraFoundationAdapterQuery,
  GamoraFoundationAdapterQueryArgs,
  GamoraFoundationAdapterQueryOperator,
} from '../query.js';
import { GamoraUUIDGuard } from '../../../guards/uuid.js';

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUnlockOperand = [
  string,
  GamoraUUIDGuard,
];

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUnlockResult = boolean;

/**
 * @public
 */
export type GamoraFoundationAdapterQueryUnlockArgs =
  GamoraFoundationAdapterQueryArgs<GamoraFoundationAdapterQueryUnlockOperand>;

/**
 * @public
 */
export class GamoraFoundationAdapterQueryUnlock extends GamoraFoundationAdapterQuery<
  GamoraFoundationAdapterQueryUnlockOperand,
  GamoraFoundationAdapterQueryUnlockResult
> {
  protected override _operator: GamoraFoundationAdapterQueryOperator =
    GamoraFoundationAdapterQueryOperator.UNLOCK;
  constructor(args: GamoraFoundationAdapterQueryUnlockArgs) {
    super(args);
  }

  /**
   * Constructs query
   * @param operand The operand
   */
  static override fromOperand(
    operand: GamoraFoundationAdapterQueryUnlockOperand,
    options?: any,
  ): GamoraFoundationAdapterQueryUnlock {
    return new GamoraFoundationAdapterQueryUnlock({
      operand,
      options,
    });
  }
}
